<app-notes [moduleId]="moduleId" [entityId]="staffId" [isCurrentUser]="true" urlPrefix="/myProfile"></app-notes>
